import React, { Component } from 'react';
import FakeData from '.././fake-data';
import ReactDOM from 'react-dom';
import { Helmet } from "react-helmet";
import { Link, Redirect, Prompt } from 'react-router-dom';
import './Event.css';

import { ChangePictureIcon, BannerShimmer, LiveGames, PostItem, EmptyState, LoadingState, GlobalTMFeeds, GlobalTMForm, LeagueSplitView, ConfirmModal, ItemPicker, Modal, ComboBox, PhotoAddModal, TagView, MomentPickerModal, EditGameModal, PublicityPicker } from '.././components/Common';
import { EventViewCreateForm1, EventViewSplitPane, EventGroupChatCreate, LocationPicker } from '.././components/Event';
import Avatar from '.././components/Avatar';
import GroupEvents from '.././components/GroupEvents';
import GroupMembers from '.././components/GroupMembers';
import Photos from '.././components/Photos';
import Videos from '.././components/Videos';
import InternalNoticeCenter from '.././components/InternalNoticeCenter';

const Trojan = window.Trojan;
const Croppie = window.Croppie;
const $ = window.$;
const jQuery = window.jQuery;
const { google } = window;

export default class Event extends Component {
    constructor(props) {
        super(props);
        this.state = {
            event: { id: null, name: "Event", image: "", error: false },
            activeTab: 'timeline',
            tabs: [
                { val: "timeline", key: "Timeline", notices: [] },
                { val: "about", key: "About", notices: [] }
            ],
            posts: [],
            isLoadingPosts: true,
            yourVideos: [],
            yourPhotos: [],
            events: [],
            albums: [],
            limit: 30,
            aboutLimit: 150,
            isEdittingAbout: false,
            isShowingUsers: false,
            isChangingPoster: false,
            aboutText: ""
        }
    }

    componentWillMount() {
        const s = new Trojan.style("league").kill()
        FakeData.mountState("event", true)
    }

    componentDidMount() {
        const _that = this
        setTimeout(() => {
            _that.getProfile()
            //_that.getPosts()
            /*_that.getEvents()
            _that.getYourPhotos()
            _that.getYourVideos()*/
            var params = FakeData.getQueries(_that.props.location.search);
            _that.setState({ activeTab: (params.sInit) ? params.sInit : "about" });
        }, 1000)

        //document.querySelector("#root").addEventListener('scroll', this.onScroll);
    }

    onPostAdded = (post) => {
        //console.log(this.state.posts.length);
        this.state.posts.unshift(post)
        this.setState({
            posts: this.state.posts
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.match.params.id !== nextProps.match.params.id || this.props.location.search !== nextProps.location.search) {
            const _that = this
            FakeData.mountState("event", false)
            this.setState({
                event: { id: null }
            });
            const s = new Trojan.style("league").kill()

            setTimeout((() => {
                FakeData.mountState("event", true)
                _that.getProfile()
                //_that.getPosts()
                /*_that.getEvents()
                _that.getYourPhotos()
                _that.getYourVideos()*/
                var params = FakeData.getQueries(nextProps.location.search);
                _that.setState({ activeTab: (params.sInit) ? params.sInit : "about" });
            }), 1000)

            return true;
        }

        if (this.props.location.search !== nextProps.location.search) {
            var params = FakeData.getQueries(nextProps.location.search);
            this.setState({ activeTab: params.sInit });
        }

        return true
    }

    componentWillUnmount() {
        FakeData.mountState("event", false)
        //window.removeEventListener('scroll', this.onScroll);
        //document.querySelector("#root").removeEventListener('scroll', this.onScroll);
    }

    getProfile = () => {
        const _that = this
        const dataTo = {
            userId: FakeData.getData('yoo').id,
            userType: "F",
            id: this.props.match.params.id
        }

        FakeData.post("/getEvent.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("event")) {
                    return
                }

                //_that.state.tabs[6].notices = _that.getUnreadNotices(res.notices);
                //_that.state.tabs[1].notices = res.requests;
                _that.setState({
                    event: res,
                    //tabs: _that.state.tabs
                });
                setTimeout((() => {
                    _that.getProfile()
                }), 5000)
            }),
            error: ((err) => {

            })
        })
    }

    getPosts = () => {
        const _that = this
        const dataTo = {
            user: FakeData.getData("yoo"),
            userTo: {
                id: this.state.event.id,
                type: "E"
            },
            clubs: [],
            leagues: [],
            teams: [],
            limit: this.state.limit
        }

        FakeData.post("/getPosts.php?auth0", dataTo, {
            success: ((res) => {
                if (!FakeData.isMounted("event")) {
                    return
                }
                _that.setState({
                    posts: res,
                    isLoadingPosts: false
                })

                setTimeout((() => {
                    _that.getPosts()
                }), 10000)
            }),
            error: ((err) => {
                console.log(err);
            })
        })
    }

    initMap = (elem) => {
        const _that = this
        this.mapProp = {
            center: new google.maps.LatLng(51.508742, -0.120850),
            zoom: 9,
            disableDefaultUI: true
        };
        this.map = new google.maps.Map(elem, this.mapProp);
        this.marker = new google.maps.Marker({ position: this.mapProp.center, animation: google.maps.Animation.BOUNCE, draggable: false });
        this.marker.setMap(this.map);
        //var nw = new google.maps.LatLng(this.map.getBounds().getNorthEast().lat(), this.map.getBounds().getSouthWest().lng());

        //this.map.panTo(nw);
        this.map.panBy(100, -100)
    }

    getDummy = (_num) => {
        const list = [];
        for (var index = 0; index < _num; index++) {
            list.push({ text: index })
        }

        return list;
    }

    getEventUsers = (txt) => {
        const { tabs, event, activeTab, posts, yourPhotos, yourVideos, albums, events } = this.state;
        const list = FakeData.listify(event.invites).filter((item) => {
            return item.status === txt;
        })

        return list;
    }

    inFriends = (user) => {
        const users = FakeData.listify(FakeData.getData("yoo").friends);
        let bool = false;
        for (var i = 0; i < users.length; i++) {
            if (users[i].id === user.id) {
                bool = true;
                break;
            }
        }

        return bool;
    }

    inSelection = (user, users) => {
        let bool = false;
        for (var i = 0; i < users.length; i++) {
            if (users[i].id === user.id) {
                bool = true;
                break;
            }
        }

        return bool;
    }

    inInvites = (user, users) => {
        let bool = false;
        for (var i = 0; i < users.length; i++) {
            if (users[i].user.id === user.id) {
                bool = true;
                break;
            }
        }

        return bool;
    }

    addFriend = (user) => {
        const _that = this;
        const dataTo = {
            user: FakeData.getData("yoo"),
            data: {
                user,
                tag: "friend",
                privacy: "1",
                type: "friends"
            }
        }

        FakeData.post("/addRelationShip.php?auth0", dataTo, {
            success: ((res) => {
                FakeData.alert("Friend request sent!");
            }),
            error: ((err) => {

            })
        }, true, "", ((res) => { }))
    }

    getFriends = () => {
        const { event } = this.state
        const list = FakeData.listify(FakeData.getData("yoo").friends).filter((item) => {
            return !this.inInvites(item, event.invites);
        })

        return list;
    }

    interested = () => {
        const { event } = this.state;
        const _that = this;
        const dataTo = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: event.created,
            eventId: event.id,
            isInterested: true
        }

        FakeData.post("/addToEvent.php?auth0", dataTo, {
            success(res) {
                FakeData.alert("Done!");
            },
            error(err) {

            }
        }, true, "", (t) => { })
    }

    saveAbout = () => {
        const _that = this;
        const { aboutText, event } = this.state;

        if (aboutText.length < 100) {
            FakeData.alert("Event description tags can not be less than 100 characters!");
            return;
        }

        const url = "/updateTable.php?auth0&ref=events";

        const data = {
            data: { Description: aboutText },
            query: "EventID='" + event.id + "'",
            user: { id: FakeData.getData("yoo").id, type: "F" },
            userTo: { id: event.id, type: "E" }
        }

        FakeData.post(url, data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Coundn't update data!");
                } else {
                    FakeData.alert("Saved!");
                    _that.setState({ isEdittingAbout: false });
                }
            },
            error(err) {
                FakeData.alert("Coundn't update data!");
                //<Developed by="" website="" facebook="" twitter="" instagram="" google-plus=""/>
            }
        }, true, "", (t) => { })
    }

    changeAttendStatus = (txt) => {
        const { event } = this.state;
        const dataTo = {
            id: event.id,
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: event.created,
            status: txt
        }

        const _that = this;

        FakeData.post("/acceptEventInvite.php?auth0", dataTo, {
            success(r) {
                FakeData.alert("Done!");
                _that.refs.root.focus()
            },
            error(r) {
                FakeData.alert("Couldn't reached server!");
                _that.refs.root.focus()
            }
        }, true, "", () => { })
    }

    getYou = () => {
        const id = FakeData.getData("yoo").id;
        const { event } = this.state;
        const list = FakeData.listify(event.invites).filter((item) => {
            return item.user.id === id;
        })

        if (list.length === 0) {
            return false;
        }

        return list[0];
    }

    updateNotice = (notice, value, id) => {
        const _this = this;
        const data = {
            id,
            notice,
            value
        }

        //console.log(data)
        FakeData.post("/updateEventNotice.php?auth0", data, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Couldn't update settings! Try again later!")
                    _this.refs['notice'].blur()
                } else {
                    FakeData.alert("Done!")
                    _this.refs['notice'].blur()
                }
            },
            error(err) {
                FakeData.alert("Couldn't update settings! Try again later!")
                _this.refs['notice'].blur()
            }
        }, true, "", (r) => { })
    }

    render = () => {
        const { tabs, event, activeTab, posts, yourPhotos, yourVideos, albums, events, aboutLimit, isChangingPoster, isEdittingAbout, isShowingUsers } = this.state
        if (event.error) {
            return (
                <Redirect to={{ pathname: "/404", state: null }} />
            )
        }

        if (event.id === null) {
            return (
                <BannerShimmer />
            );
        }

        return (
            <div className="group-profile" style={{ width: "75vw" }} ref={"root"} tabIndex={0}>
                {this.is && <div className="event-side-view" style={{ width: "25vw", minHeight: "100vh", marginRight: "0.5vw" }}>
                    <div className="event-side-view-head">
                        <Link to={{ pathname: "/events", search: "?ref=event_" + event.id }}>Back to events</Link>
                        <h3>{event.name}</h3>
                        <span>Hosted by <a>{event.managers[0].name}</a></span>
                        <hr />
                        <span><i className="material-icons">my_location</i> {event.place}</span>
                        {event.isOneDay &&
                            <span><i className="material-icons">event</i> {event.normalDate}</span>
                        }
                        {event.isOneDay &&
                            <span><i className="material-icons">alarm</i>{event.startTime + " - " + event.endTime}</span>
                        }
                        {!event.isOneDay &&
                            <span><i className="material-icons">event</i> {event.dateRange}</span>
                        }
                        {!event.isOneDay &&
                            <span><i className="material-icons">alarm</i>{event.timeRange}</span>
                        }
                    </div>
                    <div className="event-side-view-content">
                        <MapView coord={event.coord}>

                        </MapView>
                        <div className="event-side-map-overlay">
                            <div style={{ width: "100%", height: "5vw", display: "flex" }}>
                                {
                                    this.getDummy(5).map((item, i) => {
                                        var hue = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
                                        return (
                                            <div key={i} style={{ width: "5vw", height: "5vw", background: "#fff", opacity: i < 1 ? 0 : 1 }} className="">

                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div style={{ width: "100%", height: "5vw", display: "flex" }}>
                                {
                                    this.getDummy(5).map((item, i) => {
                                        var hue = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
                                        return (
                                            <div key={i} style={{ width: "5vw", height: "5vw", background: i < 3 ? "#fff" : i == 3 ? "#C4C3BC" : "#4F595C", opacity: i < 2 ? 0 : 1 }} className="">
                                                {i === 3 &&
                                                    <div className="event-map-ov-item" style={{ width: "100%", height: "100%", color: FakeData.getLuminance(i == 3 ? "#C4C3BC" : "#4F595C") }}>
                                                        <h4>{FakeData.shortDigit(this.getEventUsers("interested").length).text}</h4>
                                                        <span>Interested</span>
                                                    </div>
                                                }
                                                {i === 4 &&
                                                    <div className="event-map-ov-item" style={{ width: "100%", height: "100%", color: FakeData.getLuminance(i == 3 ? "#C4C3BC" : "#4F595C") }}>
                                                        <h4>{event.day}</h4>
                                                        <span>{FakeData.months[event.month - 1].substring(0, 3)}</span>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div style={{ width: "100%", height: "5vw", display: "flex" }}>
                                {
                                    this.getDummy(5).map((item, i) => {
                                        var hue = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
                                        return (
                                            <div key={i} style={{ width: "5vw", height: "5vw", background: i < 4 ? "#fff" : "#FFC742", opacity: i < 3 ? 0 : 1 }} className="">
                                                {i === 4 &&
                                                    <div className="event-map-ov-item" style={{ width: "100%", height: "100%", color: FakeData.getLuminance("#FFC742") }}>
                                                        <h4>{FakeData.shortDigit(this.getEventUsers("yes").length).text}</h4>
                                                        <span>Going</span>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div style={{ width: "100%", height: "5vw", display: "flex" }}>
                                {
                                    this.getDummy(5).map((item, i) => {
                                        var hue = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
                                        return (
                                            <div key={i} style={{ width: "5vw", height: "5vw", background: i < 5 ? "#fff" : hue, opacity: i < 4 ? 0 : 1 }} className="">

                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div style={{ width: "19.5vw", height: "5vw", display: "flex", flexDirection: "column", justifyContent: "center", paddingLeft: "10px", position: "absolute", left: 0, right: 0, top: 0, marginLeft: "5vw" }}>
                                <span className="event-ov-contact">
                                    <i className="material-icons">email</i>
                                    <a href={"mailto:" + event.managers[0].email}>{event.managers[0].email}</a>
                                </span>
                                <span className="event-ov-contact">
                                    <i className="material-icons">phone</i>
                                    <a href={"tel:" + event.managers[0].phone}>{event.managers[0].phone}</a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>}

                <EventKnowledgeCard event={event} hasBackLink={true} style={{}} h3style={{}}/>
                <div style={{ width: "50vw", minHeight: "100vh" }}>
                    <div className="event-banner" style={{ width: "100%", height: "30vw", position: "relative" }}>
                        <div style={{ width: "100%", height: "20vw" }}>
                            <img style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center", background: "#eee" }} src={event.file.url} />
                        </div>
                        <div style={{ width: "100%", height: "10vw", background: "#555", position: "relative" }}>
                            <div style={{ width: "20vw", height: "10vw", display: "flex", flexDirection: "column", padding: "10px", alignItems: "center", justifyContent: "center", fontSize: "13px", textAlign: "center", background: "#394453", color: "#fff", position: "absolute", right: 0, bottom: 0, marginBottom: "5vw", marginRight: "5vw" }}>
                                {event.desc.substring(0, 150)}... {(activeTab === "timeline" && event.desc.length > 150) && <a onClick={() => this.setState((state, props) => { return { activeTab: "about" } })} style={{ color: "#4ac" }}>Read More</a>}
                            </div>
                            <div style={{ width: "100%", height: "5vw", display: "flex" }}>
                                {
                                    this.getDummy(10).map((item, i) => {
                                        //var hue = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
                                        return (
                                            <ColorBox items={this.getEventUsers("yes")} i={i} key={i} />
                                        )
                                    })
                                }
                            </div>
                            <div style={{ width: "100%", height: "5vw", display: "flex" }}>
                                {
                                    this.getDummy(10).map((item, i) => {
                                        //var hue = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
                                        return (
                                            <ColorBox items={this.getEventUsers("interested")} i={i} key={i} />
                                        )
                                    })
                                }
                            </div>
                            <div className="action-buttons" style={{
                                position: "absolute",
                                left: 0,
                                bottom: 0,
                                marginLeft: "10px",
                                color: "#fff"
                            }}>
                                {(!this.inInvites(FakeData.getData("yoo"), event.invites) && !event.isAdmin) && <div onClick={this.interested.bind(this)}><i className="material-icons">add</i>Interested</div>}
                                {(this.inInvites(FakeData.getData("yoo"), event.invites)) &&
                                    <div className="inline-not-settings" ref="notice" tabIndex={0} onClick={() => { }}>
                                        <i className="material-icons">settings</i>Your status
                                        <div className="inline-not-settings-content">
                                            <span className={this.getYou().status === "yes" ? "active" : ""} onClick={() => this.changeAttendStatus("yes")}>Yes</span>
                                            <span className={this.getYou().status === "maybe" ? "active" : ""} onClick={() => this.changeAttendStatus("maybe")}>Maybe</span>
                                            <span className={this.getYou().status === "no" ? "active" : ""} onClick={() => this.changeAttendStatus("no")}>No</span>
                                        </div>
                                    </div>
                                }
                                {(this.inInvites(FakeData.getData("yoo"), event.invites) || !event.isAdmin) &&
                                    <div className="inline-not-settings" ref="notice" tabIndex={0} onClick={() => { }}>
                                        <i className="material-icons">settings</i>Notifications
                                        <div className="inline-not-settings-content">
                                            <span className={event.noticeConfig.timeline_event_post.value ? "active" : ""} onClick={() => this.updateNotice("timeline_event_post", "active", event.noticeConfig.timeline_event_post.id)}>On</span>
                                            <span className={!event.noticeConfig.timeline_event_post.value ? "active" : ""} onClick={() => this.updateNotice("timeline_event_post", "deactive", event.noticeConfig.timeline_event_post.id)}>Off</span>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        {this.is &&
                            <div className="event-banner-change-poster">
                                [o]
                            </div>
                        }
                    </div>
                    <div className="event-tabs">
                        {
                            tabs.map((item, i) => {
                                return (
                                    <span key={i} className={activeTab === item.val ? "active" : ""} onClick={() => this.setState((state, props) => { return { activeTab: item.val } })}>
                                        {item.key}
                                    </span>
                                )
                            })
                        }
                    </div>
                    {activeTab === "timeline" &&
                        <div className="event-content" style={{ width: "100%", minHeight: "100vh", marginTop: "0.5vw" }}>
                            <GlobalTMForm profile={this.state.event} direct={true} withoutAlbum={true} withoutCheckIn={true} label={"Share"} style={{ marginTop: 0, marginBottom: "10px" }} user={FakeData.getData("yoo")} userType={"F"} isAdmin={false} onPostAdded={this.onPostAdded.bind(this)} postToType="E" postToId={event.id} postToName={event.name} postToImage={event.file.url} />
                            <GlobalTMFeeds page={{
                                id:this.state.event.id,
                                type: "E"
                            }} profile={this.state.event} hideSportLabel={true} styles={{ normalPosts: { marginBottom: "10px" }, gmcPosts: { marginBottom: "10px" } }} user={FakeData.getData("yoo")} userType={"F"} posts={posts}>
                                <EmptyState style={{ background: "#fff" }} isShown={(FakeData.listify(posts).length === 0 && !this.state.isLoadingPosts) ? true : false} text="No posts were found!" icon="filter_hdr" />
                                <LoadingState style={{ background: "#fff" }} isShown={this.state.isLoadingPosts} text={"Loading"} />
                            </GlobalTMFeeds>
                        </div>
                    }
                    {activeTab === "about" &&
                        <div className="event-content" style={{ width: "100%", minHeight: "100vh", marginTop: "0.5vw", background: "" }}>
                            {this.getEventUsers("yes").length > 0 &&
                                <EventContentItem showFoot={true} title={FakeData.shortDigit(this.getEventUsers("yes").length).text + " Going - " + FakeData.shortDigit(this.getEventUsers("interested").length).text + " Interested"} footText="See All" onClick={() => { this.setState({ isShowingUsers: true }) }}>
                                    <div className="event-content-users">
                                        {
                                            this.getDummy(8).map((item, i) => {
                                                return (
                                                    <div className="event-content-user" key={i} style={{ background: !this.getEventUsers("yes")[i] ? "#fff" : "" }}>
                                                        {this.getEventUsers("yes")[i] &&
                                                            <img src={this.getEventUsers("yes")[i].user.image} />
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </EventContentItem>
                            }

                            <EventContentItem showFoot={event.desc.length > 150 ? true : false} title="Details" footText={isEdittingAbout ? "Update" : aboutLimit === 150 ? "Show More" : "Show Less"} onClick={() => {
                                if (isEdittingAbout) {
                                    this.saveAbout()
                                } else {
                                    this.setState((state, props) => ({ aboutLimit: state.aboutLimit === 150 ? event.desc.length : 150 }));
                                }
                            }}>
                                <div style={{ position: "relative" }}>
                                    {event.isAdmin &&
                                        <i className="material-icons" onClick={() => this.setState((state, props) => { return { isEdittingAbout: !isEdittingAbout } })} style={{ color: "#fff", fontSize: "13px", position: "absolute", cursor: "pointer", top: 0, right: 0, margin: "-35px 10px 0px 0px" }}>{isEdittingAbout ? "close" : "edit"}</i>
                                    }
                                    {!isEdittingAbout && <span dangerouslySetInnerHTML={{ __html: FakeData.br(event.desc).substring(0, aboutLimit) }} />} {(aboutLimit === 150 && !isEdittingAbout) && "..."}
                                    {isEdittingAbout &&
                                        <AboutEditBox text={event.desc} onChange={(e) => this.setState((state, props) => { return { aboutText: e } })} />
                                    }
                                </div>
                            </EventContentItem>

                            {posts.length > 0 &&
                                <EventContentItem showFoot={true} title="Recent Posts" footText="See All" onClick={() => {
                                    this.setState({ activeTab: "timeline" });
                                }}>
                                    <div className="event-content-posts">
                                        {
                                            posts.map((item, i) => {
                                                if (i >= 3) {
                                                    return null;
                                                }
                                                return (
                                                    <div className="event-content-post" key={i} style={{ background: !this.getEventUsers("yes")[i] ? "#fff" : "" }}>
                                                        <img src={item.user.image} />
                                                        <div>
                                                            <span>
                                                                <strong>{item.user.name}</strong> - {item.content}
                                                            </span>
                                                            <span>{window.moment(item.timeAgo).calendar()}</span>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </EventContentItem>
                            }
                        </div>
                    }
                </div>

                {isShowingUsers &&
                    <InviteeList event={event} isOpen={isShowingUsers} onClose={() => { this.setState({ isShowingUsers: false }) }} />
                }
            </div >
        )
    }
}

export const EventKnowledgeCard = (props) => {
    const { event, style, hasBackLink,h3style } = props;
    return (
        <div className="event-side-view" style={{ width: "25vw", minHeight: "100vh", marginRight: "0.5vw", ...style }}>
            <div className="event-side-view-head">
                {hasBackLink && <Link to={{ pathname: "/events", search: "?ref=event_" + event.id }}>Back to events</Link>}
                <h3 style={{...h3style}}>{event.name}</h3>
                <span>Hosted by <a>{event.managers[0].name}</a></span>
                <hr />
                <span><i className="material-icons">my_location</i> {event.place}</span>
                {event.isOneDay &&
                    <span><i className="material-icons">event</i> {event.normalDate}</span>
                }
                {event.isOneDay &&
                    <span><i className="material-icons">alarm</i>{event.startTime + " - " + event.endTime}</span>
                }
                {!event.isOneDay &&
                    <span><i className="material-icons">event</i> {event.dateRange}</span>
                }
                {!event.isOneDay &&
                    <span><i className="material-icons">alarm</i>{event.timeRange}</span>
                }
            </div>
            <div className="event-side-view-content">
                <MapView coord={event.coord}>

                </MapView>
                <div className="event-side-map-overlay">
                    <div style={{ width: "100%", height: "5vw", display: "flex" }}>
                        {
                            getDummy(5).map((item, i) => {
                                var hue = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
                                return (
                                    <div key={i} style={{ width: "5vw", height: "5vw", background: "#fff", opacity: i < 1 ? 0 : 1 }} className="">

                                    </div>
                                )
                            })
                        }
                    </div>
                    <div style={{ width: "100%", height: "5vw", display: "flex" }}>
                        {
                            getDummy(5).map((item, i) => {
                                var hue = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
                                return (
                                    <div key={i} style={{ width: "5vw", height: "5vw", background: i < 3 ? "#fff" : i == 3 ? "#C4C3BC" : "#4F595C", opacity: i < 2 ? 0 : 1 }} className="">
                                        {i === 3 &&
                                            <div className="event-map-ov-item" style={{ width: "100%", height: "100%", color: FakeData.getLuminance(i == 3 ? "#C4C3BC" : "#4F595C") }}>
                                                <h4>{FakeData.shortDigit(getEventUsers(event, "interested").length).text}</h4>
                                                <span>Interested</span>
                                            </div>
                                        }
                                        {i === 4 &&
                                            <div className="event-map-ov-item" style={{ width: "100%", height: "100%", color: FakeData.getLuminance(i == 3 ? "#C4C3BC" : "#4F595C") }}>
                                                <h4>{event.day}</h4>
                                                <span>{FakeData.months[event.month - 1].substring(0, 3)}</span>
                                            </div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div style={{ width: "100%", height: "5vw", display: "flex" }}>
                        {
                            getDummy(5).map((item, i) => {
                                var hue = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
                                return (
                                    <div key={i} style={{ width: "5vw", height: "5vw", background: i < 4 ? "#fff" : "#FFC742", opacity: i < 3 ? 0 : 1 }} className="">
                                        {i === 4 &&
                                            <div className="event-map-ov-item" style={{ width: "100%", height: "100%", color: FakeData.getLuminance("#FFC742") }}>
                                                <h4>{FakeData.shortDigit(getEventUsers(event, "yes").length).text}</h4>
                                                <span>Going</span>
                                            </div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div style={{ width: "100%", height: "5vw", display: "flex" }}>
                        {
                            getDummy(5).map((item, i) => {
                                var hue = 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')';
                                return (
                                    <div key={i} style={{ width: "5vw", height: "5vw", background: i < 5 ? "#fff" : hue, opacity: i < 4 ? 0 : 1 }} className="">

                                    </div>
                                )
                            })
                        }
                    </div>
                    <div style={{ width: "19.5vw", height: "5vw", display: "flex", flexDirection: "column", justifyContent: "center", paddingLeft: "10px", position: "absolute", left: 0, right: 0, top: 0, marginLeft: "5vw" }}>
                        <span className="event-ov-contact">
                            <i className="material-icons">email</i>
                            <a href={"mailto:" + event.managers[0].email}>{event.managers[0].email}</a>
                        </span>
                        <span className="event-ov-contact">
                            <i className="material-icons">phone</i>
                            <a href={"tel:" + event.managers[0].phone}>{event.managers[0].phone}</a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

const getEventUsers = (event, txt) => {
    const list = FakeData.listify(event.invites).filter((item) => {
        return item.status === txt;
    })

    return list;
}

const getDummy = (_num) => {
    const list = [];
    for (var index = 0; index < _num; index++) {
        list.push({ text: index })
    }

    return list;
}

class AboutEditBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            about: FakeData.unbr(this.props.text)
        }
    }

    componentDidMount() {

    }

    render = () => {
        const { about } = this.state
        return (
            <textarea value={about} onChange={(e) => {
                const val = FakeData.br(e.target.value)
                this.setState({ about: e.target.value });
                this.props.onChange(val)

            }} style={{ height: "30vw", resize: "none", width: "100%", padding: "4px" }} />
        )
    }
}

class ColorBox extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            hue: 'rgb(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ')'
        }
    }

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState) {
        const { items } = this.props
        if (items.length !== nextProps.items.length) {
            return true;
        } else {
            return false;
        }
    }


    render = () => {
        const { items, i } = this.props
        const { hue } = this.state
        return (
            <div key={i} style={{ width: "5vw", height: "5vw", background: hue }} className="">
                {items[i] &&
                    <img src={items[i].user.image} style={{ width: "100%", height: "100%" }} />
                }
            </div>
        )
    }
}

class MapView extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.initMap(this.refs.map)
    }

    initMap = (elem) => {
        const _that = this;
        const { lon, lat } = this.props.coord
        this.mapProp = {
            center: new google.maps.LatLng(lat, lon),
            zoom: 9,
            disableDefaultUI: true
        };
        this.map = new google.maps.Map(elem, this.mapProp);
        this.marker = new google.maps.Marker({ position: this.mapProp.center, draggable: false });
        this.marker.setMap(this.map);
        //var nw = new google.maps.LatLng(this.map.getBounds().getNorthEast().lat(), this.map.getBounds().getSouthWest().lng());

        //this.map.panTo(nw);
        this.map.panBy(100, -60)
    }

    render = () => {
        return (
            <div className="event-side-map" ref={"map"}>

            </div>
        )
    }
}

const EventContentItem = (props) => {
    return (
        <div className="event-content-item" style={{ width: "100%", marginTop: "0.5vw", background: "#fff" }}>
            <div className="event-content-item-hd">{props.title}</div>
            <div className="event-content-item-bd">
                {props.children}
            </div>
            {props.showFoot &&
                <a className="event-content-item-ft" onClick={props.onClick}>{props.footText}</a>
            }
        </div>
    )
}

class InviteeList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "Going",
            newMember: {
                user: null
            }
        }
    }

    getDummy = (_num) => {
        const list = [];
        for (var index = 0; index < _num; index++) {
            list.push({ text: index })
        }

        return list;
    }

    getEventUsers = (txt) => {
        const { event } = this.props
        const list = FakeData.listify(event.invites).filter((item) => {
            return item.status === txt;
        })

        return list;
    }

    inFriends = (user) => {
        const users = FakeData.listify(FakeData.getData("yoo").friends);
        let bool = false;
        for (var i = 0; i < users.length; i++) {
            if (users[i].id === user.id) {
                bool = true;
                break;
            }
        }

        return bool;
    }

    inSelection = (user, users) => {
        let bool = false;
        for (var i = 0; i < users.length; i++) {
            if (users[i].id === user.id) {
                bool = true;
                break;
            }
        }

        return bool;
    }

    inInvites = (user, users) => {
        let bool = false;
        for (var i = 0; i < users.length; i++) {
            if (users[i].user.id === user.id) {
                bool = true;
                break;
            }
        }

        return bool;
    }

    addFriend = (user) => {
        const _that = this;
        const dataTo = {
            user: FakeData.getData("yoo"),
            data: {
                user,
                tag: "friend",
                privacy: "1",
                type: "friends"
            }
        }

        FakeData.post("/addRelationShip.php?auth0", dataTo, {
            success: ((res) => {
                FakeData.alert("Friend request sent!");
            }),
            error: ((err) => {

            })
        }, true, "", ((res) => { }))
    }

    getFriends = () => {
        const { event } = this.props
        const list = FakeData.listify(FakeData.getData("yoo").friends).filter((item) => {
            return !this.inInvites(item, event.invites);
        })

        return list;
    }

    getInvites = () => {
        const { event } = this.props
        const list = FakeData.listify(event.invites).filter((item) => {
            return item.status !== "interested";
        })

        return list;
    }

    invite = (user) => {
        const { event } = this.props;
        const _that = this;
        const count = this.getFriends().length;
        const dataTo = {
            user: {
                id: FakeData.getData("yoo").id,
                type: "F"
            },
            userTo: user,
            eventId: event.id,
            isInterested: false
        }

        FakeData.post("/addToEvent.php?auth0", dataTo, {
            success(res) {
                if (count === 1) {
                    _that.setState((state, props) => { return { activeTab: "Invited" } });
                }

                FakeData.alert("Done!");
            },
            error(err) {

            }
        }, true, "", (t) => { })
    }

    render = () => {
        const { activeTab } = this.state;
        const { event } = this.props
        return (
            <Modal isOpen={this.props.isOpen} onClose={this.props.onClose}>
                <div style={{ background: "#fff", width: "45vw" }} >
                    <div className="view-with-tabs">
                        <div className="view-with-tabs-head">
                            {
                                ["Going", "Interested", "Invited", "Invite"].map((item, i) => {
                                    if (item === "Invite" && this.getFriends().length === 0) {
                                        return null;
                                    }

                                    if (item === "Interested" && this.getEventUsers("interested").length === 0) {
                                        return null;
                                    }

                                    const count = item === "Going" ? this.getEventUsers("yes").length : item === "Interested" ? this.getEventUsers("interested").length : this.getInvites().length
                                    return (
                                        <div key={i} className={(item === this.state.activeTab) ? "view-with-tabs-head-item group-mem-count-holder active" : "view-with-tabs-head-item group-mem-count-holder"} onClick={() => this.setState({ activeTab: item, filter: "" })}>
                                            {item}
                                            {item !== "Invite" && <span className="group-mem-count">{FakeData.shortDigit(count, "").text}</span>}
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="view-with-tabs-body" style={{ background: "#fff", width: "45vw", minHeight: "auto", maxHeight: "25vw", overflowY: "auto" }}>
                            {activeTab === "Going" &&
                                <div style={{ width: "100%", padding: "10px" }}>
                                    {
                                        this.getEventUsers("yes").map((item, i) => {
                                            return (
                                                <Link to={{ pathname: "/profile/" + item.user.user, search: "?sInit=about" }} key={i} className="event-ls-item">
                                                    <img src={item.user.image} />
                                                    <span className="username-lbl">{item.user.name}</span>
                                                </Link>
                                            )
                                        })
                                    }
                                </div>
                            }

                            {activeTab === "Interested" &&
                                <div style={{ width: "100%", padding: "10px" }}>
                                    {
                                        this.getEventUsers("interested").map((item, i) => {
                                            return (
                                                <Link to={{ pathname: "/profile/" + item.user.user, search: "?sInit=about" }} key={i} className="event-ls-item">
                                                    <img src={item.user.image} />
                                                    <span className="username-lbl">{item.user.name}</span>
                                                </Link>
                                            )
                                        })
                                    }
                                </div>
                            }

                            {activeTab === "Invited" &&
                                <div style={{ width: "100%", padding: "10px" }}>
                                    {
                                        event.invites.map((item, i) => {
                                            if (item.status === "interested") {
                                                return null;
                                            }
                                            return (
                                                <Link to={{ pathname: "/profile/" + item.user.user, search: "?sInit=about" }} key={i} className="event-ls-item">
                                                    <img src={item.user.image} />
                                                    <span className="username-lbl">{item.user.name}</span>
                                                    <span className="status-lbl" style={{ background: item.status === "yes" ? "#44AA55" : item.status === "no" ? "#FF4433" : "#29b", color: item.status === "yes" ? FakeData.getLuminance("#44AA55") : item.status === "no" ? FakeData.getLuminance("#FF4433") : "#fff" }}>{item.status === "yes" ? "Going" : item.status === "no" ? "Not Going" : item.status === "maybe" ? "Not Sure" : item.status.capitalize()}</span>
                                                </Link>
                                            )
                                        })
                                    }
                                </div>
                            }

                            {activeTab === "Invite" &&
                                <div style={{ width: "100%", padding: "10px" }}>
                                    <div style={{ width: "100%", padding: "10px" }}>
                                        {
                                            this.getFriends().map((item, i) => {
                                                return (
                                                    <div key={i} className="event-ls-item">
                                                        <img src={item.image} />
                                                        <span className="username-lbl">{item.name}</span>
                                                        <span className="action-btn" onClick={() => { this.invite(item) }}>
                                                            <i className="material-icons">add</i>
                                                            Invite
                                                        </span>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/Event.jsx